// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/scale.js';

import { paths } from '../generated/scale';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('scale', Original, paths);
